<ng-template #alertModalFormContent role="document" let-modal>

  <app-page-comp-header #pageHeader
    [showBottomBorder]="false"
    [switch0Show]="AlertingShowAdminSwitches"
    [switch1Show]="AlertingShowAdminSwitches"
    [switch0IsDisabled]="disableTemplate"
    switch0Text="Default Template"
    [switch0Value]="defaultTemplate"
    (switch0Change)="defaultTemplateChange()"
    [switch1IsDisabled]="disableAddOnCompanyCreation"
    switch1Text="Add On Company Creation"
    [switch1Value]="addOnCompanyCreation"
    (switch1Change)="addOnCompanyCreationChange()"
    [title]="formTitle"
  >
  </app-page-comp-header>

  <form [formGroup]="alertForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body" id="alertFormDetails">
       
      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Step One</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="row"> 
        <div class="col-12">
          <div class="mb-3 border border-success rounded">
            <div class="row">
              <div class="col-12">
                <div>
                  <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                    <strong>Alert Details</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div [ngClass]="{'col-4': alertGroupId != 1, 'col-3': alertGroupId == 1}">
                <div class="mb-3 px-3">
                  <label for="name-field" class="form-label">Alert Type</label>
                  <select
                    (change)="onAlertTypeIdChange($event)"
                    class="form-select"        
                    id="alertTypeId-field"
                    formControlName="alertTypeId"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfalertAdd['alertTypeId'].errors }"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray("alertTypeId"); track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  @if(formOfalertAdd['alertTypeId'].hasError('min')) {
                    <div class="invalid-feedback">A value is required</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
              <div  [ngClass]="{'col-7': alertGroupId != 1, 'col-5': alertGroupId == 1}">
                <div class="mb-3">
                  <label for="name-field" class="form-label">Name</label>
                  <input autocomplete="no-fill" type="text" id="name-field" class="form-control" placeholder="" formControlName="name" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfalertAdd['name'].errors }" />
                  @if(formOfalertAdd['name'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{nameMaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>  
              @if (alertGroupId == 1) {
              <div class="col-3">
                <div class="mb-3">
                  @if(selectedAlertTypeId == undefined || selectedAlertTypeId == -1 || selectedAlertTypeId > 3) {
                    <label for="threshold-field" class="form-label">Threshold</label>
                  } @else if(selectedAlertTypeId == 1) {
                    <label for="threshold-field" class="form-label">Threshold {{companyCurrencySymbol}}</label>
                  } @else if(selectedAlertTypeId == 2) {
                    <label for="threshold-field" class="form-label">Threshold %</label>
                  } @else if(selectedAlertTypeId == 3) {
                    <label for="threshold-field" class="form-label">Threshold MB</label>
                  }
                  <input autocomplete="no-fill" type="text" id="threshold-field" class="form-control text-end" placeholder="" formControlName="threshold" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfalertAdd['threshold'].errors }" />
                  @if(formOfalertAdd['threshold'].hasError('min')) {
                    <div class="invalid-feedback">Must be greater than 0</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
              }
              <div class="col-1">
                <div class="mb-1">  
                  <label class="form-check-label" for="active-field">Enabled</label>
                  <div class="mt-2 px-1"> 
                    <div class="form-check form-switch form-switch-md">
                      <input class="form-check-input" style="left:-0.25em" type="checkbox" role="switch" id="active-field" formControlName="active" (change)="onActiveCheckboxChange()">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Step Two</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="row"> 
        <div class="col-12">
          <div class="mb-3 border border-success rounded" [ngClass]="{ 'is-invalid': formSubmitted && (formData['emailEnabled'].value == false && formData['notificationEnabled'].value == false && formData['smsEnabled'].value == false) }">
            <div class="row">
              <div class="col-12">
                <div>
                  <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                    <strong>Notification Methods</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"> 
              <div class="col-6">
                <div class="mb-3 px-3">
                  <div class="input-group">
                    <div class="col-2">
                      <div class="form-check form-switch form-switch-md">
                        <label class="form-check-label" for="smsEnabled-field">SMS</label>
                        <input class="form-check-input" type="checkbox" role="switch" id="smsEnabled-field" formControlName="smsEnabled">
                      </div>
                    </div>
                    <!-- <div class="col-2 flex padding-5">
                      <input type="checkbox" 
                        class="form-check-input mt-2 mr-5" 
                        id="smsEnabled-field"
                        formControlName="smsEnabled"> 
                      <label for="smsEnabled-field" class="form-label">SMS</label>
                    </div> -->
                    <div class="col-8 padding-5">
                      <select
                        (change)="onSMSChange($event)"
                        class="form-select mr-5"        
                        [attr.disabled]="!formData['smsEnabled'].value ? '' : null"
                        id="smsTemplateId-field"
                        formControlName="smsTemplateId"
                      >
                        <option></option>
                        @for (object of smsTemplates; track object.id) {
                          <option [value]="object.id">{{object.name}}</option>    
                        }
                      </select>
                    </div>
                    <div class="col-2 text-center padding-5" [ngClass]="{ 'is-invalid': formSubmitted && (formData['smsEnabled'].value == true && (!formData['smsTemplateId'].value || formData['smsTemplateId'].value == -1 )) }">
                      <div class="dropdown" [class.show]="dropDownStatus[messageTypeId].smsOpen">
                        <button type="button" class="btn btn-success dropdown-toggle"
                          (click)="defaultOpen = false; toggleDropdown('smsOpen')" 
                          [attr.aria-expanded]="dropDownStatus[messageTypeId]?.smsOpen">
                            <i class="icon nav-icon ri-settings-2-line"></i>
                        </button>
                        <ul class="dropdown-menu" [class.show]="dropDownStatus[messageTypeId].smsOpen">
                          <li><button class="dropdown-item" [disabled]="!formData['smsEnabled'].value" (click)="openSMSTemplate(true)">Create New Template</button></li>
                          <li><button class="dropdown-item" [disabled]="!CanEditSMSTemplate()" (click)="openSMSTemplate(false)">Edit Selected Template</button></li>
                          @if(showTestMessageButton) {
                            <li><button class="dropdown-item" [disabled]="!CanEditSMSTemplate() || userSimValues.length == 0" (click)="sendTestSMSGetDetails()">Send Test SMS</button></li>
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="invalid-feedback">A SMS template is required</div>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3 px-3">
                  <div class="input-group">
                    <div class="col-2 padding-5">
                      <div class="form-check form-switch form-switch-md">
                        <label class="form-check-label" for="emailEnabled-field">Email</label>
                        <input class="form-check-input" type="checkbox" role="switch" id="emailEnabled-field" formControlName="emailEnabled">
                      </div>
                    </div>
                    <div class="col-8 padding-5">
                      <select
                       (change)="onEmailChange($event)"
                        class="form-select mr-5"        
                        [attr.disabled]="!formData['emailEnabled'].value ? '' : null"
                        id="emailTemplateId-field"
                        formControlName="emailTemplateId"
                      >
                        <option></option>
                        @for (object of emailTemplates; track object.id) {
                          <option [value]="object.id">{{object.name}}</option>    
                        }
                      </select>
                    </div>
                    <div class="col-2 text-center padding-5" [ngClass]="{ 'is-invalid': formSubmitted && (formData['emailEnabled'].value == true && (!formData['emailTemplateId'].value || formData['emailTemplateId'].value == -1 )) }">
                      <div class="dropdown" [class.show]="dropDownStatus[messageTypeId].emailOpen">
                        <button type="button" class="btn btn-success dropdown-toggle"
                          (click)="defaultOpen = false; toggleDropdown('emailOpen')" 
                          [attr.aria-expanded]="dropDownStatus[messageTypeId]?.emailOpen">
                            <i class="icon nav-icon ri-settings-2-line"></i>
                        </button>
                        <ul class="dropdown-menu" [class.show]="dropDownStatus[messageTypeId].emailOpen">
                          <li><button class="dropdown-item" [disabled]="!formData['emailEnabled'].value" (click)="openEmailTemplate(true)">Create New Template</button></li>
                          <li><button class="dropdown-item" [disabled]="!CanEditEmailTemplate()" (click)="openEmailTemplate(false)">Edit Selected Template</button></li>
                          @if(showTestMessageButton) {
                            <li><button class="dropdown-item" [disabled]="!CanEditEmailTemplate() || userSimValues.length == 0" (click)="sendTestEmailGetDetails()">Send Test Email</button></li>
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="invalid-feedback">An email template is required</div>
                  </div>
                </div>
              </div>
            </div>
      
            @if (!this.AlertingHidePWA) {
            <div class="row"> 
              <div class="col-6">
                <div class="mb-1 px-3">
                  <div class="input-group">
                    <div class="col-2 padding-5">
                      <div class="form-check form-switch form-switch-md">
                        <label class="form-check-label" for="notificationEnabled-field">PWA</label>
                        <input class="form-check-input" type="checkbox" role="switch" id="notificationEnabled-field" formControlName="notificationEnabled">
                      </div>
                    </div>
                    <div class="col-8 padding-5">
                      <select
                        (change)="onNotificationChange($event)"
                        class="form-select mr-5"        
                        [attr.disabled]="!formData['notificationEnabled'].value ? '' : null"
                        id="notificationTemplateId-field"
                        formControlName="notificationTemplateId"
                      >
                        <option></option>
                        @for (object of notificationTemplates; track object.id) {
                          <option [value]="object.id">{{object.name}}</option>    
                        }
                      </select>
                    </div>
                    <div class="col-2 text-center padding-5" [ngClass]="{ 'is-invalid': formSubmitted && (formData['notificationEnabled'].value == true && (!formData['notificationTemplateId'].value || formData['notificationTemplateId'].value == -1 )) }">
                      <div class="dropdown" [class.show]="dropDownStatus[messageTypeId].notificationOpen">
                        <button type="button" class="btn btn-success dropdown-toggle"
                          (click)="defaultOpen = false; toggleDropdown('notificationOpen')" 
                          [attr.aria-expanded]="dropDownStatus[messageTypeId]?.notificationOpen">
                            <i class="icon nav-icon ri-settings-2-line"></i>
                        </button>
                        <ul class="dropdown-menu" [class.show]="dropDownStatus[messageTypeId].notificationOpen">
                          <li><button class="dropdown-item" [disabled]="!formData['notificationEnabled'].value" (click)="openNotificationTemplate(true)">Create New Template</button></li>
                          <li><button class="dropdown-item" [disabled]="!CanEditNotificationTemplate()" (click)="openNotificationTemplate(false)">Edit Selected Template</button></li>
                        </ul>
                      </div>
                    </div>
                    <div class="invalid-feedback">A PWA template is required</div>
                  </div>
                </div>
              </div>
              <div class="col-6"></div>
            </div>
            } 
          </div>
          <div class="invalid-feedback">A delivery method is required</div>
        </div>
      </div>

      @if (alertGroupId == 1) {
        <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <label class="form-label text-right"></label>
              <div class="alert border-0 {{alertColourProgress}}" role="alert">
                <strong>Step Three - Optional</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="row"> 
          <div class="col-12">
            <div class="mb-3 border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                      <strong>Action</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">       
                <div class="col-6">
                  <div class="mb-1 px-3">
    
                    <div class="input-group">
                      <div class="col-4 padding-5">
                        <div class="form-check form-switch form-switch-md">
                          <label class="form-check-label" for="throttleSpeedEnabled-field">Throttle Speed</label>
                          <input class="form-check-input" type="checkbox" role="switch" id="throttleSpeedEnabled-field" formControlName="throttleSpeedEnabled" (change)="onThrottleSpeedCheckboxChange($event)">
                        </div>
                      </div>
                      <div class="col-8 padding-5" [ngClass]="{ 'is-invalid': formSubmitted && (formData['throttleSpeedEnabled'].value == true && (!formData['throttleSpeedId'].value || formData['throttleSpeedId'].value == -1 )) }">
                        <select
                          class="form-select mr-5"        
                          [attr.disabled]="!formData['throttleSpeedEnabled'].value ? '' : null"
                          id="throttleSpeedId-field"
                          formControlName="throttleSpeedId"
                        >
                          <option selected></option>
                          @for (object of getDropdownDataObjectArray("throttleSpeedId"); track object.id) {
                            <option [ngValue]="object.id">{{object.description}}</option>    
                          }
                        </select>
                      </div>
                      <div class="invalid-feedback">A throttle speed is required</div>
                    </div>
                  </div>
                </div>
  
                <div class="col-6">
                  <div class="mb-1 px-3">
                    <div class="input-group">
                      <div class="col-4 padding-5">
                        <div class="form-check form-switch form-switch-md">
                          <label class="form-check-label" for="changePlanEnabled-field">Change Plan</label>
                          <input class="form-check-input" type="checkbox" role="switch" id="changePlanEnabled-field" formControlName="changePlanEnabled" (change)="onProductCheckboxChange($event)">
                        </div>
                      </div>
                      <div class="col-8 padding-5" [ngClass]="{ 'is-invalid': formSubmitted && (formData['changePlanEnabled'].value == true && (!formData['changePlanId'].value || formData['changePlanId'].value == -1 )) }">
                        <select
                          class="form-select mr-5"        
                          [attr.disabled]="!formData['changePlanEnabled'].value ? '' : null"
                          id="changePlanId-field"
                          formControlName="changePlanId"
                        >
                          <option selected></option>
                          @for (object of getDropdownDataObjectArray("productId"); track object.id) {
                            <option [ngValue]="object.id">{{object.description}}</option>    
                          }
                        </select>
                      </div>
                      <div class="invalid-feedback">A change plan is required</div>
                    </div>
                  </div>
                </div>
              </div>
        
              <div class="row">       
                <div class="col-6">
                  <div class="mb-3 px-3">
                    <div class="input-group">
                      <div class="col-4 padding-5">
                        <div class="form-check form-switch form-switch-md">
                          <label class="form-check-label" for="increaseLimitEnabled-field">Increase Limit {{companyCurrencySymbol}}</label>
                          <input class="form-check-input" type="checkbox" role="switch" id="increaseLimitEnabled-field" formControlName="increaseLimitEnabled" (change)="onIncreaseCheckboxChange($event)">
                        </div>
                      </div>
                      <div class="col-2 padding-5">
                        <input autocomplete="no-fill" type="text" [readonly]="!formData['increaseLimitEnabled'].value" id="increaseLimitAmount-field" class="form-control text-end" placeholder="" formControlName="increaseLimitAmount" data-lpignore="true" 
                               [ngClass]="{ 'is-invalid': formSubmitted && (formData['increaseLimitEnabled'].value == true && (!formData['increaseLimitAmount'].value || formData['increaseLimitAmount'].value <= 0 || !isNumber(formData['increaseLimitAmount'].value) )) }" />
                        @if(formSubmitted && (formData['increaseLimitEnabled'].value == true && (!formData['increaseLimitAmount'].value))) {
                          <div class="invalid-feedback">Value required</div>
                        } @else if(formSubmitted && (formData['increaseLimitEnabled'].value == true && (formData['increaseLimitAmount'].value <= 0 || !isNumber(formData['increaseLimitAmount'].value)))) {
                          <div class="invalid-feedback">Invalid value</div>
                        }
                      </div>
                      <div class="col-1 padding-5 px-1 mt-1">
                        <label class="form-check-label"> Upto </label>
                      </div>
                      <div class="col-2 padding-5">
                        <input autocomplete="no-fill" type="text" [readonly]="!formData['increaseLimitEnabled'].value" id="increaseLimitRepeatTimes-field" class="form-control text-end" placeholder="" formControlName="increaseLimitRepeatTimes" data-lpignore="true" 
                        [ngClass]="{ 'is-invalid': formSubmitted && (formData['increaseLimitEnabled'].value == true && (!formData['increaseLimitRepeatTimes'].value || formData['increaseLimitRepeatTimes'].value <= 0 || !isNumber(formData['increaseLimitRepeatTimes'].value) )) }" />
                        @if(formSubmitted && (formData['increaseLimitEnabled'].value == true && (!formData['increaseLimitRepeatTimes'].value))) {
                          <div class="invalid-feedback">Value required</div>
                        } @else if(formSubmitted && (formData['increaseLimitEnabled'].value == true && (formData['increaseLimitRepeatTimes'].value <= 0 || !isNumber(formData['increaseLimitRepeatTimes'].value)))) {
                          <div class="invalid-feedback">Invalid value</div>
                        }
                      </div>
                      <div class="col-1 padding-5 px-1 mt-1">
                        <label class="form-check-label"> Times</label>
                      </div>
                      <div class="col-2 padding-5">
                      </div>
                    </div>
                  </div>
                </div>
   
                <div class="col-6">
                  <div class="mb-3 px-3">  
                    <div class="col-4 padding-5">
                      <div class="form-check form-switch form-switch-md">
                        <label class="form-check-label" for="barService-field">Bar Service</label>
                        <input class="form-check-input" type="checkbox" role="switch" id="barService-field" formControlName="barService" (change)="onBarCheckboxChange($event)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (alertGroupId == 1) {
        <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <label class="form-label text-right"></label>
              <div class="alert border-0 {{alertColourProgress}}" role="alert">
                <strong>Step Four</strong>
              </div>
            </div>
          </div>
        </div>

        @if(showUserGroups) {
          @if(areThereUserGroupsToShow()) {
            <div class="row"> 
              <div class="col-12">
                <div class="mb-3 border border-success rounded" [ngClass]="{ 'is-invalid': formSubmitted && !userGroupValidation() }">
                  <div class="row">
                    <div class="col-12">
                      <div>
                        <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                          <strong>User Group Allocation</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">       
                    <div class="col-12">
                      <div class="mb-1 px-3">  
                        <div class="col-6 padding-5">
                          <div class="form-check form-switch form-switch-md">
                            <label class="form-label" for="allGroups-field">All Groups Included By Default</label>
                            <input class="form-check-input" type="checkbox" role="switch" id="allGroups-field" formControlName="allGroups" (change)="onAllGroupsCheckboxChange($event)">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if(showGrid()) {
                    <div class="row"> 
                      <div class="col-12">
                        <div class="mb-0 px-3">
                          <app-grid-view #gridViewGroups
                            [apiPath]="dgApiPathGroups"
                            [dgActionColumn]="dgActionColumnGroups"
                            [dgColumns]="dgColumnsGroups"
                            [dgPopup]="dgPopupGroups"
                            [dgProperties]="dgPropertiesGroups"
                            [dgTabs]="dgTabsGroups"
                            (contentReady)="onContentReadyGroups($event)"
                            (deleteButtonClick)="groupsRemoveButtonClick($event)"
                            (editButtonClick)="groupsIncludeButtonClick($event)"
                            (tabChanged)="groupsOnTabChange($event)"
                          ></app-grid-view>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="invalid-feedback">At least one userGroup needs to be included</div>
              </div>
            </div>
          } @else {
            <div class="row"> 
              <div class="col-12">
                <div class="mb-3 border border-success rounded" [ngClass]="{ 'is-invalid': formSubmitted && !userGroupValidation() }">
                  <div class="row">
                    <div class="col-12">
                      <div>
                        <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                          <strong>User Group Allocation <span style="color: #db2e46">- No User Groups Found</span></strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="row">
            <div class="col-12">
              <div class="mb-1">
                <label class="form-label text-right"></label>
                <div class="alert border-0 {{alertColourProgress}}" role="alert">
                  <strong>Step Five</strong>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="row"> 
          <div class="col-12">
            <div class="mb-3 border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                      <strong>Sim Allocation</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">       
                <div class="col-12">
                  <div class="mb-1 px-3">  
                    <div class="col-6 padding-5">
                      <div class="form-check form-switch form-switch-md">
                        <label class="form-label" for="allSims-field">All Sims Opted In By Default</label>
                        <input class="form-check-input" type="checkbox" role="switch" id="allSims-field" formControlName="allSims" (change)="onAllSimsCheckboxChange($event)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if(showGrid()) {
                <div class="row"> 
                  <div class="col-12">
                    <div class="mb-0 px-3">
                      <app-grid-view #gridView
                        [apiPath]="dgApiPath"
                        [dgActionColumn]="dgActionColumn"
                        [dgColumns]="dgColumns"
                        [dgPopup]="dgPopup"
                        [dgProperties]="dgProperties"
                        [dgTabs]="dgTabs"
                        (contentReady)="onContentReady($event)"
                        (deleteButtonClick)="OptOutButtonClick($event)"
                        (editButtonClick)="OptInButtonClick($event)"
                        (tabChanged)="onTabChange($event)"
                      ></app-grid-view>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <label class="form-label text-right"></label>
              <div class="alert border-0 {{alertColourProgress}}" role="alert">
                <strong>Step Three</strong>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12">
            <div class="mb-3 border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                      <strong>Country Coverage</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mb-3 px-3">
                    <app-alert-country-coverage #countryCoverage
                      [alert]="currentAlert"
                      [alertId]="alertId"
                      [companyId]="sureSimCompanyId"
                    ></app-alert-country-coverage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- (cellClick)="cellClick($event)" //RBW20250716 - This goes in app-grid-view, but currently causes a recursive issue  -->
    
    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="alertFormCancel()">Close</button>
              <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" (click)="alertFormSubmitAttempt()" id="add-btn-alert-edit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>    

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="alertCompletedModalHasBeenClosed()"
></app-completed-modal-form>

<!-- <app-manage-esim-modal-form #manageEsimModalForm
  (orderDataHasBeenSaved)="orderDataHasBeenSaved()"
  (eSimManagerFormCancelled)="manageEsimFormHasBeenCancelled()"
></app-manage-esim-modal-form> -->

<app-confirmation-modal-form #reassignConfirmationModal
  (modalYes)="yesReassign()"
></app-confirmation-modal-form>

<app-input-modal-form #inputModalForm
  (thisFormSaved)="inputModalFormSubmitted($event)"
  (thisFormCancelled)="inputModalFormCancelled()"
></app-input-modal-form>

<app-template-notification-modal-form #notificationTemplateModalForm
  (companyDefaultsUpdated)             ="getCommunicationTemplateDefaults()"
  (notificationTemplateModalFormClosed)="notificationTemplateModalFormClosed($event)"
></app-template-notification-modal-form>

<app-template-email-modal-form #emailTemplateModalForm
  (companyDefaultsUpdated)      ="getCommunicationTemplateDefaults()"
  (emailTemplateModalFormClosed)="emailTemplateModalFormClosed($event)"
></app-template-email-modal-form>

<app-template-sms-modal-form #smsTemplateModalForm
  (companyDefaultsUpdated)    ="getCommunicationTemplateDefaults()"
  (smsTemplateModalFormClosed)="smsTemplateModalFormClosed($event)"
></app-template-sms-modal-form>

<!-- <app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="userDataHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form> -->

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>

